// --- string-utils.js ---
// No TS, plain JS

// Escape a string to be used inside a RegExp
const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

// Build a regex for one term with options
const buildTermRegex = (term, { caseSensitive = false, wholeWord = false } = {}) => {
  const flags = caseSensitive ? "g" : "gi"
  const body = escapeRegex(term)
  const wrapped = wholeWord ? `\\b${body}\\b` : body
  return new RegExp(wrapped, flags)
}

/**
 * Check if haystack contains ANY of the terms.
 * @param {string} haystack
 * @param {string[]} terms
 * @param {{caseSensitive?: boolean, wholeWord?: boolean}} opts
 * @returns {boolean}
 */
export const containsAny = (haystack, terms, opts = {}) => {
  if (!haystack || !Array.isArray(terms) || terms.length === 0) return false
  for (const t of terms) {
    if (!t) continue
    const re = buildTermRegex(t, opts)
    if (re.test(haystack)) return true
  }
  return false
}

/**
 * Check if haystack contains ALL of the terms.
 * @param {string} haystack
 * @param {string[]} terms
 * @param {{caseSensitive?: boolean, wholeWord?: boolean}} opts
 * @returns {boolean}
 */
export const containsAll = (haystack, terms, opts = {}) => {
  if (!haystack || !Array.isArray(terms) || terms.length === 0) return false
  for (const t of terms) {
    if (!t) return false
    const re = buildTermRegex(t, opts)
    if (!re.test(haystack)) return false
  }
  return true
}

/**
 * Check if haystack starts with ANY of the prefixes (handy for productType).
 * @param {string} haystack
 * @param {string[]} prefixes
 * @param {{caseSensitive?: boolean}} opts
 * @returns {boolean}
 */
export const startsWithOneOf = (haystack, prefixes, { caseSensitive = false } = {}) => {
  if (!haystack || !Array.isArray(prefixes) || prefixes.length === 0) return false
  const base = caseSensitive ? haystack : haystack.toLowerCase()
  return prefixes.some((p) => {
    if (!p) return false
    const pref = caseSensitive ? p : p.toLowerCase()
    // allow "Type" or "Type " at start
    return base.startsWith(pref) || base.startsWith(pref + " ")
  })
}
